import { Link } from 'react-router-dom'
import type { CaixaDoMes } from '@services/gestao.js'
import { ROUTES } from '@utils/constants.js'
import { formatCurrency } from '@utils/format.js'

interface Props {
  caixa: CaixaDoMes
  compact?: boolean
}

export function CaixaMesStrip({ caixa, compact = false }: Props) {
  const temSaida = caixa.saidaLiberada > 0 || caixa.saidaSemMedir > 0
  if (!temSaida && caixa.gastoMes === 0) return null

  return (
    <div className={`cf3-caixa${caixa.comeReserva ? ' cf3-caixa--risco' : ''}`}>
      <p className='cf3-caixa__title'>Caixa de {caixa.mesLabel}</p>
      <dl className='cf3-caixa__nums'>
        <div>
          <dt>Já saiu</dt>
          <dd>{formatCurrency(caixa.gastoMes)}</dd>
        </div>
        <div>
          <dt>Pode sair (medido)</dt>
          <dd>{formatCurrency(caixa.saidaLiberada)}</dd>
        </div>
        <div>
          <dt>Sem medir</dt>
          <dd>{formatCurrency(caixa.saidaSemMedir)}</dd>
        </div>
      </dl>
      {caixa.aposPagar != null && caixa.saidaLiberada > 0 && (
        <p className='cf3-caixa__foot'>
          {caixa.comeReserva
            ? `Se pagar o que já mediu, entra na reserva. Sobram ${formatCurrency(Math.max(caixa.aposPagar, 0))} de imprevisto.`
            : `Reserva intacta depois de pagar o medido: ${formatCurrency(caixa.aposPagar)}.`}
        </p>
      )}
      {!compact && (
        <Link className='cf3-hoje__link' to={ROUTES.CONTRATOS}>
          Ver contratos
        </Link>
      )}
    </div>
  )
}
